<template>
  <div class="four-cols__item">
    <div class="four-cols__item-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FourColsItem',
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../scss/vars';
  .four-cols__item {
    width: 100%;
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
    @media (min-width: 540px) {
      width: 50%;
      margin-bottom: 50px;
    }
    @media (min-width: 992px) {
      width: 25%;
      display: flex;
      flex-flow: column;
      align-items: flex-start;
    }
    ul, ol {
      li {
        font-weight: 300;
      }
    }
  }
  .four-cols__item-container {
    width: calc(100% - 15px);
    @media (min-width: 768px) {
      // max-width: 215px;
      width: calc(100% - 36px);
    }
    h2 {
      @media (max-width: 767px) {
        font-size: 17px;
        line-height: 30px;
        margin-bottom: 15px;
      }
      color: $green-light;
      margin-bottom: 10px;
    }
    h3 {
      font-size: 21px;
      line-height: 24px;
      margin-bottom: 20px;
      color: $h3-grey;
    }
    img {
      width: 100%;
      // max-width: 214px;
      display: block;
      box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.04);
      border-radius: 4px;
      margin-bottom: 18px;
      @media (min-width: 768px) {
        margin-bottom: 28px;

      }
    }
    .t-chartbody {
      color: $grey;
      margin-bottom: 14px;
      &.t-darker-grey {
        color: $dark-grey;
      }
    }
    .t-caption {
      color: $darker-grey;
      margin-bottom: 14px;
    }
    .four-cols__icon {
      width: 100px;
      height: 100px;
      box-shadow: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FourColsItem.vue